

import { h } from 'preact';

export default function (props) {
    var styles = props.styles;
    var rest = Object.assign({}, props);
    delete rest.styles;

    return h('svg', Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 19 20"}, rest), ["\n  ", h('path', {"fill":"currentColor","fill-rule":"evenodd","d":"M6.704 17h11a1 1 0 0 1 0 2h-11a1 1 0 1 1 0-2ZM2 16a2 2 0 1 1 0 4 2 2 0 0 1 0-4Zm0 1a1 1 0 1 0 0 2 1 1 0 0 0 0-2Zm4.704-8h8a1 1 0 0 1 0 2h-8a1 1 0 1 1 0-2ZM2 8a2 2 0 1 1 0 4 2 2 0 0 1 0-4Zm0 1a1 1 0 1 0 0 2 1 1 0 0 0 0-2Zm4.704-8h11a1 1 0 0 1 0 2h-11a1 1 0 1 1 0-2ZM2 0a2 2 0 1 1 0 4 2 2 0 0 1 0-4Zm0 1a1 1 0 1 0 0 2 1 1 0 0 0 0-2Z"}, []), "\n"]);
};

        